module.exports = __webpack_public_path__ + "static/img/sass.8408a0fd.svg";